
import { Component, Prop, Vue } from 'vue-property-decorator'

import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'
import BacInput from '@/components/BacInput.vue'
import { User } from '../../lib/models/User'
import { Country } from '../../lib/models/Country'
import UIkit from 'uikit'

@Component({
  components: {
    BacButton,
    BacModal,
    BacInput
  }
})
export default class ChangeAddressModal extends Vue {
  @Prop({ default: () => new User() }) user!: User

  countries: Country[] = []

  mounted () {
    this.loadCountries()
  }

  async loadCountries () {
    this.countries = await Country.getAll({})
  }

  async updateUser () {
    await this.user.update()
    UIkit.notification({
      message: 'Teilnehmer geupdated!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }
}
